<div
    [ngClass]="{ 'square-ratio': !wrapperWidth && !wrapperHeight }"
    [ngStyle]="{
        width: wrapperWidth,
        height: wrapperHeight
    }"
    class="product-image-wrapper"
>
    <span class="align-helper"></span>
    <div
        *ngIf="variant === 'white-background'"
        class="background"
        [ngStyle]="{ width: wrapperWidth || width, height: wrapperHeight || height }"
    ></div>
    <!-- We should upgrade this to use NgOptimizedImage -->
    <img
        [src]="image | imageScale: srcWidth:srcHeight:cropMode"
        [srcset]="(image | imageScale: srcWidth2x:srcHeight2x:cropMode) + ' 2x'"
        [attr.alt]="image.name ? image.name : null"
        [height]="width"
        [width]="height"
        class="kk-intersection product-image"
        appIntersectionLazyImage
        [index]="index"
        [indexLoadingThreshold]="indexLoadingThreshold"
        *ngIf="image && image.src"
    />
    <div
        *ngIf="variant === 'gray-tint'"
        class="tint"
        [ngStyle]="{ width: wrapperWidth || width, height: wrapperHeight || height }"
    ></div>
</div>
